import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-file-code-01',
  standalone: true,
  templateUrl: './rt-icon-file-code-01.component.html',
  styleUrls: ['./rt-icon-file-code-01.component.scss']
})
export class RtIconFileCode01Component {
  @Input() width: number | string = 14;
  @Input() height: number | string = 17;
}
